import { View } from "@/styles/reactnative";
import { ThemeContext } from "@/theme/ThemeProvider";
import { useIsMobile } from "@utils/CalVW.tsx";
import React, { useContext } from "react";
import styled from "styled-components";
import CModalHeader from "../Modal/CModalHeader";
import WithdrawLeftSection from "./WithdrawLeftSection";
import WithdrawRightSection from "./WithdrawRightSection";

const PRIMARY_GRADIENT_DARK = 'linear-gradient(135deg, #007AFF 0%, #33A7FF 50%, #6236FF 100%)';
const PRIMARY_GRADIENT_LIGHT = 'linear-gradient(135deg, #007AFF 0%, #5EC6FF 50%, #B3E5FF 100%)';

const WithdrawModal = ({ setShowModal }) => {
  const { drawerBgColor } = useContext(ThemeContext).theme.COLORS;
  const {  isDarkMode } = useContext(ThemeContext);
  const theme = isDarkMode ? 'dark' : 'light';
  const isMobile = useIsMobile();

  return (
    <ModernWithdrawContainer isDarkMode={isDarkMode}>
      {/* <BackgroundGradient isDarkMode={isDarkMode} /> */}
      
      <ModalContent>
        <CModalHeader title={"withdrawList"} closeModal={() => setShowModal(false)} />
        
        <ContentWrapper isMobile={isMobile}>
          <MainSection>
            <WithdrawLeftSection setShowModal={setShowModal} />
          </MainSection>

          {!isMobile && (
            <SideSection>
              <WithdrawRightSection />
            </SideSection>
          )}
        </ContentWrapper>
      </ModalContent>
    </ModernWithdrawContainer>
  );
};

// Styled Components - TransferModal과 동일한 모던 디자인 적용
const ModernWithdrawContainer = styled.div<{ isDarkMode: boolean }>`
  width: 100%;
  height: 550px;
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  background: ${props => props.isDarkMode
    ? 'linear-gradient(135deg, #0A0A0A 0%, #1A1A1A 50%, #0F0F0F 100%)'
    : '#FDFDFD'      // theme.light.COLORS.PrimaryBg
  };
  box-shadow: ${props => props.isDarkMode
    ? '0 20px 40px rgba(0, 0, 0, 0.8), 0 15px 30px rgba(0, 0, 0, 0.6)'
    : '0 10px 30px rgba(0, 0, 0, 0.1), 0 5px 15px rgba(0, 0, 0, 0.05)'
  };
  border: 1px solid ${props => props.isDarkMode
    ? 'rgba(255, 255, 255, 0.1)'
    : '#DDE0F3'      // theme.light.COLORS.PrimaryBorder
  };
  transition: all 0.3s ease;
`;

const BackgroundGradient = styled.div<{ isDarkMode: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 150px;
  background: ${props => props.isDarkMode
    ? PRIMARY_GRADIENT_DARK
    : PRIMARY_GRADIENT_LIGHT
  };
  opacity: ${props => props.isDarkMode ? '0.15' : '0.08'};
  z-index: 0;
`;

const ModalContent = styled.div`
  position: relative;
  z-index: 1;
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const ContentWrapper = styled.div<{ isMobile: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: ${props => props.isMobile ? 'column' : 'row'};
  gap: 0px;
  margin-top: 5px;
  overflow-y: auto;
`;

const MainSection = styled.div`
  /* flex: 1; */
  width: 100%;
  
`;

const SideSection = styled.div`
  width: auto;
  margin-top: 10px;
  padding-right: 10px;
`;

export default React.memo(WithdrawModal);
